// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23fCy","largestCol":"styles_largestCol__2St0S","smallestCol":"styles_smallestCol__1FxIv"};